import { render, staticRenderFns } from "./CompPopupInfo.vue?vue&type=template&id=c0816a86"
import script from "./CompPopupInfo.vue?vue&type=script&lang=js"
export * from "./CompPopupInfo.vue?vue&type=script&lang=js"
import style0 from "./CompPopupInfo.vue?vue&type=style&index=0&id=c0816a86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports